module.exports = __webpack_public_path__ + "02_long_black.c7164586.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_long_black.png
// module id = J2x3
// module chunks = 0